var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('Banner'),_c('ServiceEcosystem'),_c('ServiceSystem')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }